export const SELLER_PROFILE_GROUP = {
    PaymentDelivery: "payment-delivery",
    StoreInfo: "store-info",
    StoreLocations: "store-locations",
};

export const SELLER_PROFILE_GROUP_STATE = {
    [SELLER_PROFILE_GROUP.PaymentDelivery]: "paymentDelivery",
    [SELLER_PROFILE_GROUP.StoreInfo]: "storeInfo",
    [SELLER_PROFILE_GROUP.StoreLocations]: "storeLocations",
};
